import {IAuthServiceV2} from "@volkswagen-onehub/authservice";
import {IdentityDataClient} from "./IdentityDataClient";

export class LoginRenewalService {
    private EXPIRATION_DELTA_MS = (5 * 60 - 10) * 1000;

    constructor(private readonly authServiceWeConnectFag: IAuthServiceV2, private readonly identityDataClient: IdentityDataClient) {
    }

    public async reloginIfNecessary(redirectUrl: string): Promise<void> {
        if (await this.loginIsRequired()) {
            await this.relogin(redirectUrl);
        }
    }

    public async relogin(redirectUrl: string) {
        await this.authServiceWeConnectFag.login('login', redirectUrl);
    }

    public async loginIsRequired(): Promise<boolean> {
        try {
            const currentTimestampMs = Date.now();
            const {lastAuthenticationDate} = await this.identityDataClient.getIdentityData();
            return currentTimestampMs >= lastAuthenticationDate + this.EXPIRATION_DELTA_MS;
        } catch (e) {
            return false; // has to be false to prevent endless loop
        }
    }
}